class ContentSlider {
    constructor() {
        this.settings = {
            slider: '.js-content-slider',
        };
    }

    init() {
        const $element = $(this.settings.slider);
        import(/* webpackChunkName: "js/slick" */ 'slick-carousel').then(() => {
            $element.slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: true,
                speed: 300,
                variableWidth: true,
                prevArrow: $('.js-slider-control .js-slider-arrow-left'),
                nextArrow: $('.js-slider-control .js-slider-arrow-right'),
                appendDots: $('.js-slider-control .js-slider-dots'),
                dots: true,
                responsive: [
                    {
                        breakpoint: 992,
                        settings: {
                            swipe: true,
                            dots: true,
                            appendDots: $('.js-slider-control.mobile .js-slider-dots'),
                        },
                    },
                ]
            });
        });
    }
}

export default ContentSlider;
